import axios from "axios";
import React, { useContext, useState } from "react";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { getError } from "../utils";
import { Store } from "../Store";

export default function Expense() {
  const [reason, setReason] = useState("");
  const [amount, setAmount] = useState("");
  const [category, setCategory] = useState("Other");
  const navigate = useNavigate();

  const { state, dispatch: ctxDispatch } = useContext(Store);
  const { userInfo } = state;

  const submitHandler = async (e) => {
    e.preventDefault();

    try {
      const { data } = await axios.post(
        "/api/expense",
        {
          amount: Number(amount),
          reason: reason,
          category: category,
        },
        {
          headers: { Authorization: `Bearer ${userInfo.token}` },
        }
      );
      toast.success("Expense recorded");
      navigate("/");
    } catch (err) {
      toast.error(getError(err));
    }
  };
  return (
    <div className="container py-5">
      <h1>Record Expense</h1>
      <Form onSubmit={submitHandler}>
        <Form.Group className="mb-3">
          <Form.Label>Reason</Form.Label>
          <Form.Control
            value={reason}
            onChange={(e) => setReason(e.target.value)}
            required
            placeholder="e.g. Monthly Rent, Electricity Bill"
          />
        </Form.Group>
        <Form.Group className="mb-3">
          <Form.Label>Amount (RWF)</Form.Label>
          <Form.Control
            type="number"
            value={amount}
            onChange={(e) => setAmount(e.target.value)}
            required
          />
        </Form.Group>
        <Form.Group className="mb-3">
          <Form.Label>Category</Form.Label>
          <Form.Select
            value={category}
            onChange={(e) => setCategory(e.target.value)}
            required
          >
            <option value="Other">Other</option>
            <option value="Salary">Salary</option>
            <option value="Stock">Stock</option>
            <option value="Utility">Utility</option>
            <option value="Rent">Rent</option>
            <option value="Maintenance">Maintenance</option>
          </Form.Select>
        </Form.Group>
        <Button variant="primary" type="submit">
          Submit Expense
        </Button>
      </Form>
    </div>
  );
}
